module.exports = __webpack_public_path__ + "img/Azure.63d22121.png";